import { createContext } from "react";

const githubConext = createContext();

export default githubConext;
